export const LOGIN = "/officer/oauth?ssotoken="
export const COUNT = "/officer/count"
export const TICKET_BY_STATUS = "/ticket"
// Officer-scoped list: returns complaints assigned to the logged-in officer
// (by target_assignee_user_id), not ones they created. Used by the dashboard
// drill-down so assigned complaints show regardless of who registered them.
export const OFFICER_TICKETS = "/officer/tickets"
export const ONE_TICKET = "/officer/ticket/"
export const UPDATE_TICKET = "/officer/ticket/action/"
export const GET_SUMMARY = "/officer/summary?"
export const ADD_SCHOOL_IMAGE = "/officer/report/school"
export const ADD_VC_IMG = "/officer/report/vcnode"
export const SCHOOL_VC_DATA = "/officer/report/user-wise"
